import styled from 'styled-components';

export const StyledIframe = styled.iframe`
  border: none;
  width: 100%;
  min-height: 100vh;

  position: absolute;
  inset: 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;

  position: relative;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  overflow: hidden;
`;

export const LoaderWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[4]}px;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[4]}px;
  flex-wrap: wrap;
`;
